function DropDown({ dropdownData }) {
  return (
    <ul
      className="text-sm"
      aria-labelledby="dropdownLargeButton"
    >
      {dropdownData.map((data,index) => (
        <li key={index + 1} className="block border-b border-gray py-2 px-4  ">
          {data}
        </li>
      ))}
    </ul>
  );
}

export default DropDown;
